import React, { useState, useEffect } from "react";
import "./ReelSelectionModel.css";
import SearchIcon from "../../assets/images/SearchIcon.svg";
import TickIcon from "../../assets/images/tickIcon.svg";
import BackArrow from "../../assets/images/BackArrow.svg";
import { videoCreatorEndPoint } from "../../Constants/constants";
import { callApi } from "../../utils/apiService";
import { useUser } from "../../Context/UserContext";
import { formatDate } from "../../utils/helpers";

export default function ReelSelectionModel({ onClose, onSelect }) {
  const [selected, setSelected] = useState(null);
  const [searchText, setSearchText] = useState("");

  const [reelList, setReelList] = useState([]);
  const { user } = useUser();
  const clearAll = () => {
    setSelected(null);
    setSearchText("");
  };

  const filteredVideos = reelList.filter((video) =>
    video.title.toLowerCase().includes(searchText.toLowerCase()),
  );

  const fetchVideoList = async () => {
    try {
      const response = await callApi(
        `${videoCreatorEndPoint}creatorData/${user?.id}/videos`,
        "GET",
      );
      if (response?.status) {
        setReelList(response?.data?.videos || []);
      }
    } catch (err) {}
  };

  useEffect(() => {
    fetchVideoList();
  }, []);

  return (
    <div className="modal-overlay">
      <div className="video-modal">
        <div className="reel-select-link">
          <img src={BackArrow} alt="back-arrow" onClick={onClose} />
          <h3>Add your reel link</h3>
        </div>

        <div className="search-input-wrapper">
          <img src={SearchIcon} alt="search" className="search-input-icon" />

          <input
            type="text"
            placeholder="Search your list..."
            value={searchText}
            className="search-text-input"
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div className="video-list">
          {filteredVideos.map((video) => (
            <div
              className={`video-item ${
                selected?.id === video.id ? "selected" : ""
              }`}
              key={video.id}
              onClick={() => setSelected(video)}
            >
              <img src={video.generatedThumbnail} alt="" />

              <div>
                <h4>{video.title}</h4>
                <p>{formatDate(video.createdAt)}</p>
              </div>
              <p
                className={`custom-radio ${
                  selected?.id === video.id ? "checked" : ""
                }`}
              >
                {selected?.id === video.id && (
                  <img className="radio-check" src={TickIcon} alt="tick" />
                )}
              </p>
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <span>{selected ? "1 VIDEO SELECTED" : "0 VIDEO SELECTED"}</span>

          <button onClick={clearAll}>CLEAR ALL</button>
        </div>

        <button className="add-video-btn" onClick={() => onSelect(selected)}>
          Add Video →
        </button>
      </div>
    </div>
  );
}
